const API_BASE_URL = (process.env.NEXT_PUBLIC_API_BASE_URL ?? "https://va-service.techfyte.com").replace(/\/$/, "");

interface ConversationTokenResponse {
  statusCode: number;
  status: boolean;
  message: string;
  type: string;
  data: {
    token: string;
  };
}

interface ConversationTokenParams {
  agentId: string;
  userId?: string;
}

const buildConversationTokenUrl = (agentId: string) =>
  `${API_BASE_URL}/v1/voice-agent/${encodeURIComponent(agentId)}/generateConversationToken`;

export async function getVoiceAgentConversationTokenAction(
  params: ConversationTokenParams,
): Promise<ConversationTokenResponse> {
  if (!params?.agentId) {
    throw new Error("Agent ID is required");
  }

  const body = params.userId ? { userId: params.userId } : {};

  try {
    const response = await fetch(buildConversationTokenUrl(params.agentId), {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(body),
      cache: "no-store",
    });

    const data = (await safeParseJson(response)) as ConversationTokenResponse | null;

    if (!response.ok) {
      const message = data?.message || "Failed to get conversation token";
      throw new Error(message);
    }

    if (!data?.data?.token) {
      throw new Error("Invalid response from conversation token endpoint");
    }

    return data;
  } catch (error) {
    console.error("Failed to get conversation token:", error);
    if (error instanceof Error) {
      throw error;
    }
    throw new Error("Failed to get conversation token");
  }
}

async function safeParseJson(response: Response) {
  try {
    return await response.json();
  } catch {
    return null;
  }
}